var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_x0020_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2845864648672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1493",
    "data-name": "Group 1493",
    transform: "translate(8.489 22.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4571",
    "data-name": "Path 4571",
    d: "M1992.877,979.93v15.7l-15.607,9.014v-15.7Z",
    transform: "translate(-1884.44 -951.903)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4572",
    "data-name": "Path 4572",
    d: "M165.671,458.248c-.119-6.007,3.778-12.044,11.709-16.628l3.276-1.883c7.812-4.513,18.057-6.766,28.308-6.766h.622c10.036.09,20.042,2.349,27.693,6.766l22.08,12.738-15.613,9.02m-22.08-12.749c-6.993-4.04-18.4-4.04-25.409,0l-3.27,1.889c-7.005,4.047-7.005,10.628,0,14.674l22.08,12.744",
    transform: "translate(-165.668 -432.97)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4573",
    "data-name": "Path 4573",
    d: "M766.058,988.085v15.7l-22.08-12.744c-6.993-4.047-18.4-4.047-25.409,0l-2.379,1.369",
    transform: "translate(-687.98 -959.562)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4574",
    "data-name": "Path 4574",
    d: "M1128.513,1478.84v15.7l-15.613,9.013v-15.7Z",
    transform: "translate(-1064.362 -1425.248)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4575",
    "data-name": "Path 4575",
    d: "M855.384,1321.242v15.7l-15.612,9.014-14.752-8.512.033-15.566,15.58-9.144Z",
    transform: "translate(-791.234 -1267.65)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4576",
    "data-name": "Path 4576",
    d: "M199.5,955.1v15.7l-22.074-12.75c-7.812-4.507-11.709-10.425-11.709-16.341V926.28c.119,5.828,4.022,11.632,11.709,16.067",
    transform: "translate(-165.717 -901.002)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4577",
    "data-name": "Path 4577",
    d: "M1727.237,1950.5a3.034,3.034,0,0,1-1.817,2.881l-9.056,5.236c-4.495,2.6-13.132.072-13.144-3.855v-.072c.018-9.988,1.728-13.03,6.7-16.509a6.626,6.626,0,0,0,11-1.907c3.6,1.883,6.3,5.314,6.312,14.226Z",
    transform: "translate(-1624.433 -1859.238)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4578",
    "data-name": "Path 4578",
    d: "M1801.894,1768.282a6.621,6.621,0,1,1,11.512-4.459,6.5,6.5,0,0,1-.508,2.552,6.626,6.626,0,0,1-11,1.907Z",
    transform: "translate(-1716.406 -1689.344)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4579",
    "data-name": "Path 4579",
    d: "M2425.091,2168.916a3.038,3.038,0,0,1-1.812,2.881l-9.062,5.236c-4.495,2.6-13.126.078-13.138-3.855v-.066c.012-9.994,1.722-13.03,6.7-16.515a6.621,6.621,0,0,0,11-1.907c3.6,1.883,6.306,5.32,6.312,14.226Z",
    transform: "translate(-2286.533 -2066.466)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4580",
    "data-name": "Path 4580",
    d: "M2433.911,1361.3a3.039,3.039,0,0,1-1.812,2.881l-9.062,5.236c-4.495,2.6-13.126.078-13.138-3.855v-.066c.012-9.994,1.722-13.031,6.7-16.516a6.621,6.621,0,0,0,11-1.907c3.6,1.883,6.306,5.32,6.312,14.226Z",
    transform: "translate(-2294.901 -1300.23)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4581",
    "data-name": "Path 4581",
    d: "M2499.639,1986.712a6.622,6.622,0,1,1,11-1.907,6.621,6.621,0,0,1-11,1.907Z",
    transform: "translate(-2378.392 -1896.581)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4582",
    "data-name": "Path 4582",
    d: "M2508.469,1179.1a6.622,6.622,0,1,1,11-1.907,6.621,6.621,0,0,1-11,1.907Z",
    transform: "translate(-2386.77 -1130.355)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4583",
    "data-name": "Path 4583",
    d: "M1719.744,822.1v15.7l-15.612,9.014L1689.38,838.3l.033-15.567,15.579-9.144Z",
    transform: "translate(-1611.302 -794.086)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 156,
    height: 156,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.132a2e77f800fb7f54f10a0947e32748.svg";
export { ForwardRef as ReactComponent };